/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { CardContent } from "@mui/material";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import { useMemo, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import TableSkeleton from "components/Skeleton/TableSkeleton";
import "./bTable.css";

export function TableLoadingRows({ columns = 5, rows = 7 }) {
  return (
    <TableSkeleton
      variant="dt"
      rows={rows}
      columns={columns}
      hasHeader={false}
    />
  );
}

createTheme(
  "solarized",
  {
    text: {
      primary: "white",
      secondary: "white",
    },
    background: {
      default: "var(--surface-primary, #191b1f)",
    },
    context: {
      background: "var(--surface-primary, #191b1f)",
      text: "white",
    },
    divider: {
      default: "white",
    },
    button: {
      default: "#ffff",
      hover: "rgba(255, 255, 255, .18)",
      focus: "rgba(255, 255, 255, .18)",
      disabled: "rgba(255, 255, 255, .18)",
    },
    sortFocus: {
      default: "#ffff",
    },
  },
  "dark"
);
createTheme(
  "light",
  {
    text: {
      primary: "black",
      secondary: "black",
    },
    background: {
      default: "white",
    },
    context: {
      background: "white",
      text: "black",
    },
    divider: {
      default: "gray",
    },
    button: {
      default: "#00000",
      hover: "rgba(0, 0, 0, .18)",
      focus: "rgba(0, 0, 0, .18)",
      disabled: "rgba(0, 0, 0, .18)",
    },
    sortFocus: {
      default: "#00000",
    },
  },
  "dark"
);

export function BTable(props) {
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor, tableBorder } = getColorMappings(sidenavColor);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const globalLoading = useSelector((state) => state.loader.isLoading);
  const tableLoading =
    props.loading !== undefined
      ? props.loading
      : props.progressPending !== undefined
      ? props.progressPending
      : globalLoading;
  const [deleteHeading, setDeleteHeading] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [values, setValues] = useState({
    _id: [],
  });

  const handleSort = async (column, sortDirection) => {
    if (sortDirection === "asc") {
      props.sortingType(column.sortField, 1);
    } else {
      props.sortingType(column.sortField, -1);
    }
  };

  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records?");
      if (selectedRows) {
        values._id = [];
        for (let element of selectedRows) {
          values._id.push(element._id);
        }
        props.handleMultipleDeleteData(values._id, deleteHeading);
      }
    };
    return (
      <MDButton onClick={handleDeleteMultiple} color="error">
        Delete
      </MDButton>
    );
  }, [selectedRows]);

  const customStyles = {
    table: {
      style: {
        borderColor: tableBorder,
      },
    },
    headRow: {
      style: {
        color: darkMode ? "white" : "white",
        background: barColor,
        minHeight: "30px",
      },
    },
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
        color: "white",
      },
    },

    pagination: {
      style: {
        border: "none",
      },
    },
    rows: {
      style: {
        minHeight: "35px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Records Per Page",
  };

  return (
    // <div style={{ position: 'relative', top: '10',width: '100%' ,marginTop:"-8px"}}>
    <CardContent
      style={{ height: props.data.length > 10 ? "612px" : "fit-content" }}
    >
      <DataTable
        title={props.title}
        columns={props.columns}
        theme={darkMode ? "solarized" : "light"}
        data={props.data}
        progressPending={tableLoading}
        progressComponent={
          props.progressComponent || (
            <TableLoadingRows columns={props.columns?.length || 5} />
          )
        }
        selectableRows={props.selectableRows}
        onSort={handleSort}
        onRowClicked={props.rowClicked}
        sortServer
        pagination={props.pagination}
        paginationServer={Boolean(props.onChangePage)}
        paginationTotalRows={props.paginationTotalRows}
        onChangeRowsPerPage={props.onChangeRowsPerPage}
        onChangePage={props.onChangePage}
        customStyles={customStyles}
        contextActions={props.contextActions}
        onSelectedRowsChange={props.onSelectedRowsChange}
        selectableRowDisabled={props.selectableRowDisabled}
        conditionalRowStyles={props.conditionalRowStyles}
        clearSelectedRows={props.clearSelectedRows}
        // fixedHeaderScrollHeight={props.fixedHeaderScrollHeight}
        fixedHeaderScrollHeight={props.data.length > 10 ? "548px" : "500px"}
        fixedHeader={true}
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10]}
        paginationComponentOptions={paginationComponentOptions}
      />
    </CardContent>
    // </div>
  );
}

// import { CardContent } from "@mui/material";
// import { getColorMappings } from "components/ColorComponent/ColorComponent";
// import MDButton from "components/MDButton";
// import { useMaterialUIController } from "context";
// import { useMemo, useState, useEffect } from "react";
// import DataTable, { createTheme } from "react-data-table-component";

// createTheme(
//   'solarized',
//   {
//     text: {
//       primary: 'white',
//       secondary: 'white',
//     },
//     background: {
//       default: 'var(--surface-primary, #191b1f)',
//     },
//     context: {
//       background: 'var(--surface-primary, #191b1f)',
//       text: 'white',
//     },
//     divider: {
//       default: 'white',
//     },
//     button: {
//       default: '#ffff',
//       hover: 'rgba(255, 255, 255, .18)',
//       focus: 'rgba(255, 255, 255, .18)',
//       disabled: 'rgba(255, 255, 255, .18)',
//     },
//     sortFocus: {
//       default: '#ffff',
//     },
//   },
//   'dark',
// );

// createTheme(
//   'light',
//   {
//     text: {
//       primary: 'black',
//       secondary: 'black',
//     },
//     background: {
//       default: 'white',
//     },
//     context: {
//       background: 'white',
//       text: 'black',
//     },
//     divider: {
//       default: 'gray',
//     },
//     button: {
//       default: '#00000',
//       hover: 'rgba(0, 0, 0, .18)',
//       focus: 'rgba(0, 0, 0, .18)',
//       disabled: 'rgba(0, 0, 0, .18)',
//     },
//     sortFocus: {
//       default: '#00000',
//     },
//   },
//   'dark',
// );

// export function BTable(props) {
//   const [controller] = useMaterialUIController();
//   const { darkMode, sidenavColor } = controller;
//   const { barColor, tableBorder } = getColorMappings(sidenavColor);
//   const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
//   const [deleteHeading, setDeleteHeading] = useState("");
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [values, setValues] = useState({
//     _id: []
//   });
//   const [data, setData] = useState([]);

//   // useEffect(() => {
//   //   if (props.data.length < 20) {
//   //     const defaultData = [...props.data];
//   //     while (defaultData.length < 20) {
//   //       defaultData.push({ id: defaultData.length + 1 });
//   //     }
//   //     setData(defaultData);
//   //   } else {
//   //     setData(props.data);
//   //   }
//   // }, [props.data]);

//   const handleSort = async (column, sortDirection) => {
//     if (sortDirection === "asc") {
//       props.sortingType(column.sortField, 1)
//     }
//     else {
//       props.sortingType(column.sortField, -1)
//     }
//   };

//   const contextActions = useMemo(() => {
//     const handleDeleteMultiple = () => {
//       setDeleteDialogeFlag(!deleteDialogeFlag);
//       setDeleteHeading("Would you like to delete selected records?");
//       if (selectedRows) {
//         values._id = []
//         for (let element of selectedRows) {
//           values._id.push(element._id);
//         }
//         props.handleMultipleDeleteData(values._id, deleteHeading)
//       }
//     };
//     return (
//       <MDButton onClick={handleDeleteMultiple} color="error" >
//         Delete
//       </MDButton>
//     );
//   }, [selectedRows]);

//   const customStyles = {
//     table: {
//       style: {
//         borderColor: tableBorder,
//       },
//     },
//     headRow: {
//       style: {
//         color: darkMode ? "white" : "white",
//         background: barColor,
//         minHeight: '30px',
//       },
//     },
//     headCells: {
//       style: {
//         fontWeight: 'bold',
//         fontSize: '14px',
//         color: "white",
//       },
//     },
//     pagination: {
//       style: {
//         border: 'none',
//       },
//     },
//     rows: {
//       style: {
//         minHeight: '50px',
//       },
//     },
//   };

//   const paginationComponentOptions = {
//     rowsPerPageText: 'Records per page:',
//   };

//   const cardHeight = props.data.length > 20 ? 'fit-content' : '610px' && props.data.length > 10 ? 'fit-content' : '450px' ;

//   return (
//     <CardContent style={{ height: cardHeight }}>
//       <DataTable
//         title={props.title}
//         columns={props.columns}
//         theme={darkMode ? 'solarized' : 'light'}
//         data={data}
//         selectableRows={props.selectableRows}
//         onSort={handleSort}
//         onRowClicked={props.rowClicked}
//         sortServer
//         pagination={props.pagination}
//         paginationServer
//         paginationTotalRows={props.paginationTotalRows}
//         onChangeRowsPerPage={props.onChangeRowsPerPage}
//         onChangePage={props.onChangePage}
//         customStyles={customStyles}
//         contextActions={props.contextActions}
//         onSelectedRowsChange={props.onSelectedRowsChange}
//         selectableRowDisabled={props.selectableRowDisabled}
//         conditionalRowStyles={props.conditionalRowStyles}
//         clearSelectedRows={props.clearSelectedRows}
//         fixedHeaderScrollHeight={props.data.length > 20 ? '545px' : '600px' && props.data.length > 10 ? '548px' : '380px' }
//         fixedHeader={true}
//         paginationPerPage={20}
//         paginationComponentOptions={paginationComponentOptions}
//       />
//     </CardContent>
//   )
// }
